import {
  GET_DND_SUCCESS,
  GET_DND_COUNT_SUCCESS,
  DND_TOGGLE_FLAG,
} from '../actions/dnd/dnd.actiontype';

const INITIAL_STATE = {
  allIds: [],
  byId: {},
  count: 0,
  dndToggleFlag: false,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_DND_SUCCESS:
      return {
        ...state,
        ...action.data,
      };
    case GET_DND_COUNT_SUCCESS:
      return {
        ...state,
        count: action.data,
      };
    case DND_TOGGLE_FLAG:
      return {
        ...state,
        dndToggleFlag: !state.dndToggleFlag,
      };
    default:
      return state;
  }
};

export default reducer;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
